import dayjs from 'dayjs';

export const getImageryDate = (showImageryDate: boolean, imageDate: Date) => {
  if (!showImageryDate) {
    return;
  }
  return `Imagery Date: ${dayjs(imageDate).format('MM/DD/YYYY')} `;
};

export const getCopyright = (imageDate: Date, imageProvider: string) => {
  const copyright = [];
  const year = imageDate.getFullYear();

  if (imageProvider === 'PHR') {
    copyright.push(`© CNES (${year}), Distribution Airbus DS`);
  }
  if (['PNE', 'PNEO', 'SPOT'].includes(imageProvider)) {
    copyright.push(`© Airbus DS (${year})`);
  }
  if (imageProvider === 'Legion') {
    copyright.push(
      `Satellite imagery © [${new Date().getFullYear()}] Maxar Technologies.`
    );
  }
  if (imageProvider === 'VexcelOrtho') {
    copyright.push(
      `Image Copyright Vexcel Group [${new Date().getFullYear()}]`
    );
  }

  return copyright.join(', ');
};
